// Constants
import { FOOTER_PARTNERS, FOOTER_PARTNERS_ENUMS } from "constants/partners";

// Images
// import GamingCuracao from "assets/images/glory/partners_gaming.svg?react";
// import GamingCuracaoBanger from "assets/images/glory/partners_gaming_banger.svg?react";

import "./styles.sass";
import classNames from "classnames";

const FooterPartnersList = () => {
  // const { VITE_APP_PROJECT_NAME } = import.meta.env;
  // const curacao =
  //   VITE_APP_PROJECT_NAME === "glory" ? (
  //     <GamingCuracao />
  //   ) : (
  //     <GamingCuracaoBanger />
  //   );

  return (
    <div className="FooterPartners">
      {/* {VITE_APP_PROJECT_NAME === "banger" ? (
        <a
          className="FooterPartners-item__img"
          href="https://licensing.gaming-curacao.com/validator/?lh=c59b82fd8a349cb55b9658ccbef529f0"
          target="__blank"
        >
          {curacao}
        </a>
      ) : null} */}
      {FOOTER_PARTNERS.map((partner) => {
        const imgClass = classNames("FooterPartners-item__img", {
          gcb: partner.id === FOOTER_PARTNERS_ENUMS.GCB,
        });
        return (
          <div className="FooterPartners-item" key={partner.id}>
            <a href={partner.link} target="_blank" rel="noreferrer">
              {partner.icon && (
                <div className="FooterPartners-item__icon" key={partner.id}>
                  {partner.icon}
                </div>
              )}
              {partner.image && (
                <div className={imgClass} key={partner.id}>
                  <img src={partner.image} alt={partner.id.toString()} />
                </div>
              )}
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default FooterPartnersList;
